import { render, staticRenderFns } from "./CollectedItems.vue?vue&type=template&id=a53dd290&"
import script from "./CollectedItems.vue?vue&type=script&lang=js&"
export * from "./CollectedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports